<template>
    <div style="padding-top:65px;">
        <div class="swiper-container">
            <!-- <img src="static/images/home/1.png" alt=""> -->
            <swiper :options="swiperOption" ref="mySwiper">
                <swiper-slide><img src="static/images/home/1.png" alt=""></swiper-slide>
                <swiper-slide><img src="static/images/home/2.png" alt=""></swiper-slide>
                <div class="swiper-button-prev" slot="button-prev"></div>
                <div class="swiper-button-next" slot="button-next"></div>
            </swiper>
        </div>
        <div class="content">
            <div class="clearfix">
                <div class="list">
                    <ul id="game-list">
                        <li class="ui-game-9" v-for="item in tableData" :key="item.id">
                            <el-link type="primary" @click="GoTo('dlete',{id:item.id})">
                                <img :src="'http://47.94.243.146:8081/upload/'+item.photo[0]" alt=''>
                                <p>
                                    <a href="javascript:;" style=" ">{{item.title}}</a>
                                </p>
                            </el-link>
                        </li>
                    </ul>
                </div>
                <!--置顶等-->
                <div class="announcepost">
                    <div class="announcecorp">
                        <!--上层 tab 栏-->
                        <div id="tab1">
                            <ul>
                                <li onmouseover="setTab(1,0)" class="now">发布推荐</li>
                            </ul>
                        </div>
                        <!--下层 列表-->
                        <div id="tablist1">
                            <div class="tablist block course">
                                <ul>
                                    <li v-for="(item,index) in tableData" :key="index">
                                        <span class="title">
                                            <el-link type="primary" @click="GoTo('dlete',{id:item.id})">
                                                <a href="javascript:;" style=" ">{{(index+1)+'.'+item.title}}</a>
                                            </el-link>
                                        </span><span class="money" title="手机转让">手机转让</span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { productList } from "@/lib/api.js";
export default {
    name: "Home",
    data() {
        return {
            swiperOption: {
                // some swiper options/callbacks
                // 所有的参数同 swiper 官方 api 参数
                // ...
                loop: true,
                navigation: {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev",
                },
                autoplay: {
                    delay: 3000,
                    disableOnInteraction: false,
                },
            },
            tableData: [],
        };
    },
    computed: {
        swiper() {
            return this.$refs.mySwiper.swiper;
        },
    },
    mounted() {
        // current swiper instance
        // 然后你就可以使用当前上下文内的swiper对象去做你想做的事了
        // console.log("this is current swiper instance object", this.swiper);
        this.swiper.slideTo(1, 1000, false);
        this.getlist();
    },
    methods: {
        getlist() {
            productList()
                .then((res) => {
                    this.tableData = res;
                    this.tableData.forEach((element) => {
                        element.photo = element.photo.split("#");
                    });
                })
                .catch((err) => {});
        },
    },
};
</script>

<style lang="scss" scoped>
.button {
    text-align: center;
}
.swiper-container {
    height: 580px !important;
}
.list {
    width: 852px;
    float: left;
    height: 405px !important;
    #game-list {
        li {
            width: 236px;
            display: inline-block;
            vertical-align: top;
            float: none;
            zoom: 1;
            margin: 0 12px 20px 12px;
            img {
                width: 100%;
                height: 157.33px;
                overflow: hidden;
                cursor: pointer;
            }
            p {
                margin: 0 auto;
                text-align: center;
                width: 220px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                word-break: keep-all;
                font-size: 14px;
                line-height: 20px;
            }
        }
    }
}
.announcepost {
    width: 336px;
    height: 385px !important;
    float: right;
    display: block;
    border: 1px #e3e3e3 solid;
    height: auto;
    overflow: auto;
    background-color: #fff;
}
.announcecorp #tab1 {
    height: 36px;
    font-size: 14px;
    line-height: 36px;
    background-color: #2a91da;
    color: white;
    border-bottom: 1px #e3e3e3 solid;
    .now {
        line-height: 36px;
        color: white;
    }
}
li,
ol,
ul {
    list-style: none;
}
.announcecorp #tab1 li {
    display: block;
    width: 70px;
    height: 36px;
    /* float: left; */
    /* margin-right: 15px; */
    text-align: center;
    margin: 0 auto;
}
.announcecorp .tablist {
    width: 314px;
    height: 235px;
    overflow: hidden;
    background-color: #fff;
    margin: 0 auto;
}
.announcecorp .tablist ul {
    margin: 5px 10px 5px 10px;
    padding: 0 5px 0 5px;
}
.announcecorp .tablist li {
    width: 290px;
    padding-left: 5px;
    padding-right: 5px;
    height: 32px;
    line-height: 32px;
    overflow: hidden;
    font-size: 14px;
}
.tablist li span.title {
    height: 26px;
    line-height: 26px;
    float: left;
    display: block;
    overflow: hidden;
    width: 220px;
}
a:link,
a:visited,
ins {
    text-decoration: none;
}
a,
a:link {
    color: #333;
    text-decoration: none;
}
a:-webkit-any-link {
    color: #333;
    cursor: pointer;
}
.tablist li span.money {
    text-align: right;
    width: 60px;
    height: 26px;
    float: right;
    display: block;
    text-align: left;
    color: #999 !important;
    font-size: 14px;
    overflow: hidden;
}
.courseschool {
    border-top: 1px #eee solid;
    height: auto;
    overflow: auto;
    margin: 10px 15px 10px 15px;
}

a.postinfo,
a.postmember {
    text-align: center;
    height: 34px;
    line-height: 34px;
    display: block;
    /* float: left; */
    margin: 0 auto;
    color: #fff;
    text-decoration: none;
    cursor: pointer;
    border: 0;
    margin-top: 10px;
    font-size: 14px;
    width: 145px;
    border-radius: 2px;
}
a.postinfo {
    margin-left: 1px;
    background-color: #2a91da !important;
    margin: 0 auto;
    width: 80%;
}
.infolist .showbox .hd .postinfo a:hover,
.page_nav .menu a:hover {
    text-decoration: none;
}
.infolist,
.infolist .showbox {
    margin-top: 5px;
    margin-bottom: 5px;
    height: auto;
    /*overflow: auto;*/
    overflow: hidden;
    margin: 20px 0;
}
.infolist .sleft {
    float: left;
}
.infolist .sright {
    float: right;
}
.infolist .showbox .hd {
    height: 40px;
    background-color: #fafafa;
    line-height: 40px;
}
.infolist .showbox .hd {
    /*border-top: 1px #ff9900 solid;*/
    background: url("~static/images/imgs/l-n.png");
    /*border-radius: 15px;*/
    margin-bottom: 5px;
}
.infolist .showbox .hd {
    border-top: 1px #42b712 solid;
}
.infolist .showbox .hd {
    /*border-top: 1px #f78015 solid;*/
    background: url("~static/images/imgs/l-n.png");
}
.infolist .showbox .hd {
    border-top: 1px #c40000 solid;
}
.infolist .showbox .hd .cattitle img {
    width: 30px;
    height: 30px;
    -webkit-border-radius: 4px;
    border-radius: 4px;
    vertical-align: top;
    margin-top: 5px;
}
.infolist .showbox .hd .cattitle {
    /*float: left;*/
    text-align: center;
    display: block;
    padding-right: 15px;
    padding-left: 10px;
    height: 40px;
    font-weight: 700;
    font-size: 16px;
    line-height: 40px;
    color: #ff6600;
}
.infolist .showbox .hd .cattitle span {
    float: left;
    display: block;
    width: 2px;
    height: 40px;
}
.infolist .showbox .hd .postinfo {
    float: left;
    display: block;
    margin-left: 15px;
}
.infolist .showbox .hd .postinfo a {
    color: #333;
}
.infolist .showbox .hd .moreinfo {
    float: right;
    display: block;
    margin-right: 10px;
    width: 120px;
    text-align: right;
}
.infolist .showbox .bd ul {
    margin: 10px 10px;
    text-align: left;
    display: flex;
    justify-content: space-around;
    align-items: center;
    flex-wrap: wrap;
}
.infolist .showbox .bd ul li {
    width: 31%;
    overflow: hidden;
    height: 42px;
    /*font-size: 14px;*/
    font-size: 12px;
    line-height: 42px;
    border-bottom: 1px #f1f1f1 solid;
    background: url(~static/images/index/li_arrow.gif) 5px 20px no-repeat;
}
.infolist .showbox .bd ul li:last-child {
    border-bottom: none;
}
.infolist .showbox .bd ul li.bg_gray {
    background-color: #fbfcfc;
}
.infolist .showbox .bd li .time {
    float: left;
    display: block;
    /*width: 35px;*/
    height: 38px;
    color: #585858;
    text-align: left;
    margin-left: 15px;
}
.infolist .showbox .bd li .info {
    float: left;
    display: block;
    overflow: hidden;
    margin-left: 7px;
    height: 38px;
    text-align: left;
    width: 220px;
    text-overflow: ellipsis;
    white-space: nowrap;
    word-break: keep-all;
    font-size: 12px;
    line-height: 42px;
}
.infolist .showbox .bd li .catname {
    /*float: right;*/
    float: left;
    display: block;
    overflow: hidden;
    width: 65px;
    height: 38px;
    text-align: left;
    margin-left: 15px;
}
.infolist .showbox .bd li .catname a {
    margin-left: 7px;
    color: #999;
}
</style>


// WEBPACK FOOTER //
// src/components/Home.vue